export default "__VITE_ASSET__CoXVS3Yp__"